export default "__VITE_ASSET__etdE99Ek__"